import React, { useEffect, useState, useCallback } from "react";
import { getStaffListApi } from "../../api/staffService";
import Button from "../../utils/Buttons";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
function StaffList(props) {
  const userId = props.userId;
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const loadStaff = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getStaffListApi();
      setStaff(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    loadStaff();
  }, [loadStaff]);
  const handleAddStaff = () => {
    navigate("/staff/add", { state: { userId } });
  };
  const handleEdit = (staffId) => {
    navigate("/staff/edit", { state: { userId: userId ,staffId } });
  };
  return (
    <div className="container mt-4">
      <div className="card p-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5>Staff List</h5>
          {JSON.parse(localStorage.getItem("user"))?.role === "ADMIN" && (
            <Button
              text="Add Staff"
              icon={<FiPlus size={15} />}
              className="btn btn-primary"
              onClick={handleAddStaff}
            />
          )}
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <table className="table table-bordered table-hover">
            <thead className="bg-light">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>Role</th>
                {JSON.parse(localStorage.getItem("user"))?.role === "ADMIN" && (
                  <th>Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              {staff.length === 0 ? (
                <tr>
                  <td colSpan="5">No Staff Found</td>
                </tr>
              ) : (
                staff.map((item) => (
                  <tr key={item._id}>
                    <td>{item.fullName}</td>
                    <td>{item.email}</td>
                    <td>
                      <Button
                        text={item.status}
                        className={`badge ${
                          item.status === "ACTIVE" ? "info" : "secondary"
                        } m-2 p-2 border-0`}
                      />
                    </td>
                    <td>{item.role}</td>
                    {JSON.parse(localStorage.getItem("user"))?.role ===
                      "ADMIN" && (
                      <td className="text-center">
                        <Button
                          icon={<i className="fe fe-edit"></i>}
                          className="btn btn-sm btn-outline-dark"
                          onClick={() => handleEdit(item._id)}
                        />
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
export default StaffList;
